export default {
      id: "descending-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#descending-usage",
      toString: function () {
        return this.url;
      }
    }